var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 328,
    height: 1,
    viewBox: "0 0 328 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "card-divider",
    y1: 0.5,
    x2: 328,
    y2: 0.5,
    stroke: "#27272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDivider);
export default __webpack_public_path__ + "static/media/card-divider.8f56eb7e6422b687ed2deb6ecf28f3b0.svg";
export { ForwardRef as ReactComponent };